import { render, staticRenderFns } from "./formatcurrency.vue?vue&type=template&id=25744e82&"
import script from "./formatcurrency.vue?vue&type=script&lang=js&"
export * from "./formatcurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25744e82')) {
      api.createRecord('25744e82', component.options)
    } else {
      api.reload('25744e82', component.options)
    }
    module.hot.accept("./formatcurrency.vue?vue&type=template&id=25744e82&", function () {
      api.rerender('25744e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22I4Ey5vyGV0W/JS/formatcurrency.vue"
export default component.exports